export const faqs = [
  {
    question: 'Onde fica o ATMOS?',
    answer: 'O ATMOS está localizado na Av. Visconde de Guarapuava, 2807, Centro, Curitiba - PR. Uma localização estratégica com acesso direto à Av. Sete de Setembro e Av. Marechal Floriano Peixoto, a apenas 7 quadras do Batel.',
  },
  {
    question: 'Qual a entrega prevista?',
    answer: 'A entrega do empreendimento ATMOS está prevista para setembro de 2028. O cronograma de obras segue rigorosamente o planejamento da ATR Incorporadora.',
  },
  {
    question: 'Quantas unidades são?',
    answer: 'O ATMOS conta com 326 unidades, sendo o primeiro empreendimento da nova linha de estúdios da ATR chamada VOLT, desenvolvido em parceria com a HOUSI.',
  },
  {
    question: 'Quais tipologias e metragens?',
    answer: 'O ATMOS oferece: Garden com pé direito duplo (5,30m livre) de 21,42m² a 22,98m²; Estúdios com pé direito Plex (4,10m livre) de 21,46m² a 23,81m²; Estúdios com pé direito normal de 15,62m² a 24,27m²; 1 quarto com pé direito Plex (4,10m livre) de 30,17m²; 1 quarto com pé direito normal de 24,27m² a 29,50m²; 2 quartos compactos com pé direito normal de 37,46m² a 40,45m².',
  },
  {
    question: 'Quais os principais diferenciais?',
    answer: 'O ATMOS se destaca pela fachada contemporânea, estacionamento rotativo no subsolo, mais de 25 áreas de lazer, aquecimento central de água (sistema hoteleiro), convenção de condomínio Airbnb Friendly, elevador panorâmico e integração com o Appspace conectando o empreendimento a mais de 80 marcas e serviços.',
  },
  {
    question: 'Como receber tabela e disponibilidade?',
    answer: 'Entre em contato com a Levalo pelo WhatsApp (41) 98867-4555 ou preencha o formulário nesta página. Nossa equipe enviará a tabela completa com valores e disponibilidade atualizada. Aproveite a fase de venda antecipada com condições especiais da tabela zero.',
  },
  {
    question: 'O que é a linha VOLT da ATR?',
    answer: 'VOLT é a nova linha de estúdios da ATR Incorporadora, focada em unidades compactas e modernas. O ATMOS é o primeiro empreendimento desta linha, desenvolvido em parceria com a HOUSI para oferecer máxima funcionalidade e design contemporâneo.',
  },
  {
    question: 'O que é o Appspace?',
    answer: 'O Appspace é uma plataforma que conecta o empreendimento a mais de 80 marcas e serviços, oferecendo aos moradores acesso facilitado a diversos benefícios, conveniências e experiências exclusivas através de um único aplicativo.',
  },
];
